// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mdi-information[data-v-444591d6]{position:absolute;top:-20px;right:20px}.container .mdi-information[data-v-444591d6]{top:30px}@media only screen and (max-width:460px){.container .mdi-information[data-v-444591d6]{top:60px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
